<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>

          <CCardBody>
            <BTabs :active-tab.sync="active_tab" >
<!--              <CTab  :title="$t('jashnvare')">-->
<!--                <Eshantions/>-->
<!--              </CTab>-->

              <CTab  :title="$t('AddSalesPlan')">
                <SalesPlanAdd/>
              </CTab>
              <CTab  :title="$t('salesPlan')">
                <SalesPlanList/>
              </CTab>
<!--              <CTab  :title="$t('sidebars.visitorTargets')">-->
<!--                <VisitorTargets/>-->
<!--              </CTab>-->
<!--              <CTab title="متد های فروش"  v-if="get_access('sell_method')">-->
<!--                <SaleMethods/>-->
<!--              </CTab>-->
<!--              <CTab :title="$t('cars')">-->
<!--                <InsertWheicle/>-->
<!--              </CTab>-->


              <CTab title="فروش مستقیم تامین کننده" v-if="get_access('sell_supplier_direct')">
                <DirectSellSupplier/>
              </CTab>


            </BTabs>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import BTabs from "../../tabs/BTabs";

var items = [];
import VisitorTargets from "../visitors/VisitorTargets";
import Eshantions from "../eshantion/EshantionComponent";
import SaleMethods from "../accounting/SaleMethods";
import SalesPlanAdd from "./SalesPlanAdd";
import SalesPlanList from "./SalesPlanList";
import DirectSellSupplier from "../settings/DirectSellSupplier";
export default {
  name: 'Login',
  components: {
    BTabs,
    VisitorTargets,
    Eshantions,
    SaleMethods,
    SalesPlanAdd,
    SalesPlanList,
    DirectSellSupplier
  },
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,

      active_tab:parseInt(localStorage.getItem("sell_program_setting_active_tab",0)),

    }
  }, mounted() {
    this.$root.root_validate_errors = [];


  }, watch: {

    'active_tab': function () {
      localStorage.setItem("sell_program_setting_active_tab",this.active_tab)
    }
  },
  methods: {

  }
}

</script>
